import React from 'react';
import Footer from '../components/Footer';
import SubFooter from '../components/SubFooter';
import Img from "../assets/maya.jpg";
import HighestImg from "../assets/courses/highest.gif";
import AvgImg from "../assets/courses/avg.png";
import YearImg from "../assets/courses/year.gif";
import { ChevronRight, Award, Book, Briefcase, Users, Check, Star, BookOpen, GraduationCap, Building, Globe } from 'lucide-react';
import vc from "../assets/aboutus/vc.png";
import President_img from "../assets/aboutus/president.png";

// Added certification logos
const certifications = [
  { id: 1, name: 'UGC', alt: '' },
  // { id: 2, name: 'NAAC A+', alt: '' },
  { id: 3, name: 'AICTE', alt: '' },
  { id: 4, name: 'PCI', alt: '' },
];

const stats = [
  {
    id: 1,
    name: 'Highest Package',
    value: '43.6 Lakh',
    image: HighestImg,
    icon: <Award className="w-8 h-8 text-blue-600" />
  },
  {
    id: 2,
    name: 'Average Package',
    value: '5.48 Lakh',
    image: AvgImg,
    icon: <Briefcase className="w-8 h-8 text-green-600" />
  },
  {
    id: 3,
    name: 'Years of Excellence',
    value: '15',
    image: YearImg,
    icon: <Star className="w-8 h-8 text-yellow-500" />
  },
];

const universityEdge = [
  {
    id: 1,
    title: 'Excellence in Education',
    description: 'Curriculum designed by industry experts and academicians',
    icon: <BookOpen className="w-10 h-10 text-blue-600" />
  },
  {
    id: 2,
    title: 'Industry-Oriented Curriculum',
    description: 'Programs aligned with industry demands and global standards',
    icon: <Building className="w-10 h-10 text-green-600" />
  },
  {
    id: 3,
    title: 'Innovation & Research Focus',
    description: 'State-of-the-art research facilities and innovation centers',
    icon: <Globe className="w-10 h-10 text-purple-600" />
  },
  {
    id: 4,
    title: 'Holistic Development',
    description: 'Focus on academic, personal and professional growth',
    icon: <Users className="w-10 h-10 text-red-500" />
  }
];

const whyChooseUs = [
  { id: 1, text: 'Student-focused ecosystem' },
  { id: 2, text: 'Industry tie-ups with leading organizations' },
  { id: 3, text: 'Robust placement & internship support' },
  { id: 4, text: 'Thriving research and innovation culture' },
  { id: 5, text: 'State-of-the-art infrastructure' },
  { id: 6, text: 'Global exposure through international collaborations' }
];

export default function About() {
  return (
    <div className="w-full relative bg-white mt-20">
      {/* Hero Section with NAAC Banner */}
      {/* Hero Section with NAAC Banner */}
      <div className="relative overflow-hidden bg-gradient-to-r from-green-900 to-green-700 py-20">
        <div className="absolute inset-0 opacity-20">
          <div className="h-full w-full bg-gradient-to-r from-green-900 to-green-700"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-10">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Welcome to Maya Devi University
          </h1>
          <p className="text-xl text-green-100 max-w-3xl mx-auto">
            Empowering minds, transforming lives, and shaping the future through excellence in education.
          </p>
          <div className="mt-8 inline-flex items-center px-6 py-3 bg-white text-green-700 font-semibold rounded-full shadow-lg hover:bg-green-50 transition-all duration-300">
            {/* <span className="mr-1">NAAC A+ Accredited</span> */}
            <Star className="w-5 h-5 text-yellow-500 ml-1" fill="currentColor" />
          </div>
        </div>
      </div>

      {/* Vision & Mission Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-12">
            Vision & Mission
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="flex items-center mb-4">
                <div className="bg-blue-100 p-3 rounded-full">
                  <BookOpen className="w-8 h-8 text-blue-700" />
                </div>
                <h3 className="text-2xl font-bold text-blue-900 ml-4">Our Vision</h3>
              </div>
              <p className="text-gray-700 text-lg">
                To be a globally recognized center of excellence in education, research and innovation,
                nurturing holistic development of students and contributing to societal transformation.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="flex items-center mb-4">
                <div className="bg-green-100 p-3 rounded-full">
                  <GraduationCap className="w-8 h-8 text-green-700" />
                </div>
                <h3 className="text-2xl font-bold text-blue-900 ml-4">Our Mission</h3>
              </div>
              <p className="text-gray-700 text-lg">
                To provide quality education through innovative teaching methodologies,
                foster research and entrepreneurship, promote ethical values, and prepare
                students to meet global challenges with confidence and integrity.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* University Edge Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-4">
            The University Edge
          </h2>
          <p className="text-gray-600 text-center max-w-3xl mx-auto mb-12">
            What sets Maya Devi University apart from the rest
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {universityEdge.map((item) => (
              <div key={item.id} className="bg-white border border-gray-100 p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 hover:border-blue-200">
                <div className="mb-4">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-blue-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Us Content */}
      <section className="py-16 bg-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-12 items-center">
            <div className="lg:w-1/2">
              <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6">
                About Maya Devi University
              </h2>
              <p className="text-gray-700 text-lg mb-4">
                With 15 years of legacy, established in the year 2010, Maya Group of Colleges is now Maya Devi University under the Uttarakhand Private University (Amendment) Act 2024, (Act No. – 05, 2024).
              </p>
              <p className="text-gray-700 text-lg mb-4">
                Maya Devi University, with its world-class infrastructure, social values, high standards of learning & research, and strong corporate & industry interface, is a right launch pad for aspiring technocrats, entrepreneurs & would-be managers.
              </p>
              <p className="text-gray-700 text-lg">
                We are committed to promoting Professional Education in Engineering, Agriculture, Management, Applied Sciences, Pharmacy, Hotel Management, Tourism, Disaster Management, Holistic Studies, Commerce, Animation, and Computer Application.
              </p>
            </div>
            <div className="lg:w-1/2">
              <img
                src={Img}
                alt="Maya Devi University Campus"
                className="rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-12">
            Our Achievements
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {stats.map((stat) => (
              <div
                key={stat.id}
                className="bg-white shadow-lg p-8 rounded-xl flex flex-col items-center transition-all duration-300 hover:shadow-xl hover:translate-y-[-5px] border-t-4 border-blue-600"
              >
                <div className="mb-4">
                  {stat.icon}
                </div>
                <p className="text-4xl font-bold text-blue-900 mb-2">{stat.value}</p>
                <p className="text-xl font-medium text-gray-600">{stat.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Accreditations Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-4">
            Accreditations & Recognitions
          </h2>
          <p className="text-gray-600 text-center max-w-3xl mx-auto mb-12">
            Our university takes pride in meeting the highest standards of educational excellence
          </p>
          <div className="flex flex-wrap justify-center gap-8 items-center">
            {certifications.map((cert) => (
              <div key={cert.id} className="p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300">
                <div className="flex items-center justify-center w-32 h-32 bg-gray-100 rounded-full mx-auto mb-4">
                  <p className="text-xl font-bold text-blue-900">{cert.name}</p>
                </div>
                <p className="text-center text-gray-600">{cert.alt}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Leadership Message Section */}
      <section className="py-16 bg-white">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="bg-gradient-to-r from-emerald-900 to-emerald-700 rounded-2xl shadow-xl overflow-hidden">
      <div className="flex flex-col md:flex-row">
        <div className="md:w-1/3 bg-emerald-800 p-8 flex items-center justify-center">
          <div className="w-48 h-48 rounded-full overflow-hidden border-4 border-white shadow-lg">
            <img
              src={President_img}
              alt="President Maya Devi University"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="md:w-2/3 p-8 md:p-12">
          <h2 className="text-3xl font-bold text-white mb-4">Message from the President</h2>
          <p className="text-emerald-100 text-lg mb-6">
            "At Maya Devi University, we are committed to nurturing not just skilled professionals, but
            compassionate, ethical, and socially responsible individuals who will contribute meaningfully
            to society. Our focus on innovation, research, and holistic development prepares our students
            to excel in a rapidly evolving global landscape."
          </p>
          <p className="text-white font-bold text-lg">Mr. Manohar Lal Juyal</p>
          <p className="text-emerald-200">President, Maya Devi University</p>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* Why Choose Us Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-4">
            Why Maya Devi University is the Preferred Choice
          </h2>
          <p className="text-gray-600 text-center max-w-3xl mx-auto mb-12">
            Discover the advantages that make us stand out in the educational landscape
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {whyChooseUs.map((item) => (
              <div key={item.id} className="flex items-start space-x-4">
                <div className="mt-1 bg-green-100 p-2 rounded-full">
                  <Check className="w-5 h-5 text-green-600" />
                </div>
                <div>
                  <p className="text-lg font-medium text-gray-800">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}